export default "__VITE_ASSET__FHOj88LS__"